import { render, staticRenderFns } from "./mamari-detail-contents.vue?vue&type=template&id=98ad2966&lang=pug&"
import script from "./mamari-detail-contents.vue?vue&type=script&lang=js&"
export * from "./mamari-detail-contents.vue?vue&type=script&lang=js&"
import style0 from "./mamari-detail-contents.vue?vue&type=style&index=0&id=98ad2966&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports